module.exports = __webpack_public_path__ + "static/media/icon_webrtc.b0c031e8.png";